import { Component } from "@angular/core";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
import { SimpleModalComponent } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.component";

@Component({
  selector: "ngx-contact-us-modal",
  templateUrl: "./contact-us-modal.component.html",
  styleUrls: ["./contact-us-modal.component.scss"],
})
export class ContactUsModalComponent extends SimpleModalComponent<ConfirmModel, boolean> {
  currentInformation = this.authService.currentInformation();

  constructor(private authService: AuthService) {
    super();
  }

  close() {
    this.closeModal();
  }
}
export interface ConfirmModel {}
